var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import lodash from 'lodash';
import { action, observable } from 'mobx';
import { EnumAPI } from '../../apis';
import Env from '../../env';
import { AjaxBasics, BaseModel } from './../../libraries';
import { createUserModel } from './userInfo';
//目前仅支持0 or 非0
var UserPermission;
(function (UserPermission) {
    UserPermission[UserPermission["Both"] = 0] = "Both";
    UserPermission[UserPermission["ChatOnly"] = 1] = "ChatOnly";
    UserPermission[UserPermission["EmojiOnly"] = 2] = "EmojiOnly";
    UserPermission[UserPermission["None"] = 3] = "None";
})(UserPermission || (UserPermission = {}));
export class LiveController {
    constructor() {
        this.Model = new BaseModel({ type: 'object' });
        //用户数据
        this.UserInfo = createUserModel();
        this.isLoading = true;
    }
    get liveId() {
        return lodash.get(this.UserInfo.value, 'liveId');
    }
    //直播间房间信息
    get liveRoomInfo() {
        return lodash.get(this.Model.value, 'liveRoomInfo');
    }
    //聊天权限
    get chatPermission() {
        return lodash.get(this.liveRoomInfo, 'chatShow', 0);
    }
    //0深色1浅色
    get roomThemeColor() {
        const liveBackground = lodash.get(this.liveRoomInfo, 'liveBackground');
        return liveBackground == 0 ? '深色' : '浅色';
    }
    //0横屏1竖屏
    get mobileRoomType() {
        return lodash.get(this.liveRoomInfo, 'liveVideoAttribute', 0);
    }
    get mobileRoomSize() {
        return this.mobileRoomType == 0
            ? {
                height: '210px',
                width: '100%',
            }
            : {
                height: '100%',
                width: '100%',
            };
    }
    //非本地表情
    get liveEmoji() {
        return lodash.get(this.Model.value, 'liveEmoji', []);
    }
    onToggleLoading(state) {
        this.isLoading = state;
    }
    async getLiveRoomInfo() {
        try {
            const response = await AjaxBasics.request(lodash.assign(EnumAPI.live_attribute, {
                body: {
                    liveId: this.liveId,
                },
            }));
            this.Model.merge({
                liveRoomInfo: response,
            });
        }
        catch (error) { }
    }
    async getLiveEmoji() {
        try {
            const response = await AjaxBasics.request(lodash.assign(EnumAPI.live_emoji_find, {
                body: {
                    liveId: this.liveId,
                },
            }));
            const parseRes = lodash.map(response, (item) => {
                const url = new URL(item.emojiLink);
                return {
                    'icon': Env.release ? item.emojiLink : location.origin + url.pathname,
                    'value': Env.release
                        ? item.emojiLink
                        : location.origin + url.pathname,
                    'label': item.emojiName,
                };
            });
            this.Model.merge({
                liveEmoji: parseRes,
            });
        }
        catch (error) { }
    }
}
__decorate([
    observable
], LiveController.prototype, "isLoading", void 0);
__decorate([
    action.bound
], LiveController.prototype, "onToggleLoading", null);
